// src/components/AudioSyncInitializer.js
import React, { useEffect, useRef } from 'react';
import { initGlobalAudio } from '../../utils/audioManager';
import AudioSyncCoordinator from './AudioSyncCoordinator';

function AudioSyncInitializer() {
  const coordinatorRef = useRef(null);
  const initAttemptedRef = useRef(false);

  useEffect(() => {
    if (initAttemptedRef.current) return;
    initAttemptedRef.current = true;

    if (typeof window === 'undefined') return;

    // Garantir a promise global de ready
    if (!window.audioSyncReady) {
      window.audioSyncReady = new Promise((resolve) => {
        window.audioSyncReadyResolve = resolve;
      });
    }

    const init = async () => {
      try {
        // Inicializar áudio global
        initGlobalAudio();

        // Criar coordinator único
        coordinatorRef.current = new AudioSyncCoordinator();

        // Expor globalmente (compat)
        window.audioSync = coordinatorRef.current;      // para useAudio
        window.audioCoordinator = coordinatorRef.current; // para useSpotQueue/useLocutor

        // Resolver promise de ready
        if (window.audioSyncReadyResolve) {
          window.audioSyncReadyResolve();
        }

        console.log('[AudioSyncInitializer] ✅ Sistema inicializado');
      } catch (error) {
        console.error('[AudioSyncInitializer] ❌ Erro:', error);
        if (window.audioSyncReadyResolve) {
          window.audioSyncReadyResolve(); // não travar
        }
      }
    };

    init();

    return () => {
      console.log('[AudioSyncInitializer] 🔄 Mantendo sistema ativo');
    };
  }, []);

  return null;
}

export default AudioSyncInitializer;
